import { CommonUserFieldsFragment } from 'generated/graphql';
import { db } from 'technical/db';
import logger from 'technical/logger';

export async function persistUserDataInLocalStorage(
  user: CommonUserFieldsFragment,
): Promise<void> {
  await db.userSession.put({ id: 'singleton', user });
}

export async function fetchUserDataFromLocalStorage(): Promise<CommonUserFieldsFragment | null> {
  try {
    const record = await db.userSession.get('singleton');
    return record?.user ?? null;
  } catch (err) {
    logger.error(err);
    return null;
  }
}
